import React, { ReactNode } from 'react';
import { ColumnType } from './ColumnType';

type NumericLocalFormat = true | React.ReactChild | React.ReactFragment | React.ReactPortal | ReactNode;

export function numericLocalFormat(content: NumericLocalFormat, columnType: ColumnType): string | NumericLocalFormat {
    if (columnType === ColumnType.NUMERIC && content && !isNaN(Number(content))) {
        content = Number(content).toLocaleString('de-DE');
        return content;
    }
    return content;
}
